import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useGetPlayersByTournament = ({setUpPlayers})=>{
            const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
            const dispatch = useDispatch();

            useEffect(()=>{
            if(!selectedTournament?._id) return;
            const url = 'https://web-production-58ed.up.railway.app/api/getPlayers/byTournament'
            const params = {
                params:{
                    torneo: selectedTournament?._id
                }
            }
    
            try {
              axios.get(url, params).then(res =>{
                return dispatch(setUpPlayers(res?.data?.jugadores))
              })
                
            } catch (error) {
                
            }
    
        },[selectedTournament?._id])

}